/* eslint-disable no-irregular-whitespace */
<script>

export default {
  name: 'ConditionsVente'
};
</script>

<template>
  <div class="content">
    <h2 class="primary--text mb-6">
      <u><b>CONDITIONS GENERALES D’UTILISATION DU SERVICE &laquo; COMMANDE ALIMENTS &raquo;</b></u>
    </h2>
    <h3 class="secondary--text">
      ARTICLE 1. PRESENTATION DU SERVICE &laquo; COMMANDE D’ALIMENTS &raquo;
    </h3>

    <p>
      La « COMMANDE D’ALIMENTS » est un service fourni par :
      <ul>
        <li><b>AGRIAL</b>, Société Coopérative Agricole à capital variable, dont le siège social est 4 rue des Roquemonts, 14000 CAEN, immatriculée au RCS de CAEN sous le numéro 428 611 719, n° agrément 10571,<b> pour les adhérents de la Coopérative.</b> </li>
        <li>et par <b>VEGAM</b> Société par actions simplifiée, au capital social de 403 032 €uros, immatriculée au R.C.S de RENNES sous le numéro 679 200 071, dont le siège social est situé 2 route de Fougères, à CESSON-SEVIGNE (35510) <b>uniquement pour ses clients professionnels agriculteurs</b> bénéficiant d’un compte Vegam et dont leurs exploitations ou le siège d’exploitation sont situées dans les départements suivants : Ille et Vilaine, Côtes d’Armor, Morbihan, Loire Atlantique, Maine et Loire, Manche, Mayenne.</li>
      </ul>
    </p>

    <p>
      Le Vendeur souhaite proposer aux Producteurs un service en ligne leur permettant de :
      <ul>
        <li>Consulter leur historique d’approvisionnement en Aliments, </li>
        <li>Commander facilement des Aliments sur un espace dédié et accessible via Monagrial ou par agrialpro.fr </li>
      </ul>
    </p>

    <h3 class="secondary--text">
      ARTICLE 2. DEFINITIONS
    </h3>

    <p>
      Dans le cadre des présentes conditions générales de vente (ci-après « CGV »), sont désignés par les termes suivant <br>
      <b>&laquo; Adhérent &raquo;</b> uniquement l’associé coopérateur Agrial. <br>
      <b>&laquo; Client &raquo;</b> uniquement le client professionnel agriculteur Vegam. <br>
      <b>&laquo; Producteur &raquo;</b> l’Adhérent ou le Client. <br>
      <b>&laquo; Vendeur &raquo;</b> l’Adhérent ou le Client. <br>
      <b>&laquo; Agrial &raquo;</b> : Société Coopérative Agricole à capital variable, dont le siège est situé 4 Rue des Roquemonts à CAEN (14000), immatriculée au R.C.S de CAEN sous le numéro 428 611 719, agrément numéro 10571. <br>
      <b>&laquo; Vegam &raquo;</b> : Société par actions simplifiée, au capital social de 403 032 €uros, immatriculée au R.C.S de RENNES sous le numéro 679 200 071, dont le siège social est situé 2 route de Fougères, à CESSON-SEVIGNE (35510). <br>
      <b>&laquo; Parties &raquo;</b> Producteur et Vendeur. <br>
      <b>&laquo; Service(s) &raquo;</b> : L’ensemble des services proposés sur l’espace spécifique &laquo; COMMANDE D’ALIMENTS &raquo;.<br>
      <b>&laquo; Site &raquo;</b> l’espace spécifique sur le web &laquo; COMMANDE D’ALIMENTS &raquo;. <br>
      <b>&laquo; Aliments &raquo;</b> : tous les aliments destinés aux ruminants, caprins, porcs et volailles, qu’ils soient composés ou simples.<br>
    </p>

    <h3 class="secondary--text">
      ARTICLE 3. CHAMP D’APPLICATION
    </h3>

    <p>
      Les présentes CGV du Service s’appliquent à toutes les opérations effectuées entre :
      <ul>
        <li>Agrial et un Adhérent, </li>
        <li>
          Vegam et un client agriculteurs professionnels, <br>
          Dès lors, si l’utilisateur du Service est un Adhérent Agrial, son (co-contractant) vendeur sera Agrial.
          Et si l’utilisateur du Service est un client agriculteurs professionnel respectant les conditions précisées ci-dessus, son (co-contractant) vendeur sera Vegam.
        </li>
      </ul>
    </p>

    <p>Les CGV précisent notamment les conditions de commande, de paiement, de livraison. </p>
    <p>Les CGV s'appliquent à l'exclusion de toutes autres conditions, et notamment celles applicables pour les ventes en magasin ou au moyen d'autres circuits conseillers, techniciens, maison de région, etc… </p>

    <h3 class="secondary--text">
      ARTICLE 4. ACCEPTATION DES CGU DU SERVICE
    </h3>
    <p>
      <b>POUR UTILISER LE SERVICE &laquo; COMMANDE D’ALIMENTS &raquo; CHAQUE PRODUCTEUR DOIT PRENDRE CONNAISSANCE ET ACCEPTER, SANS RESERVE, LES CGV PAR UN MECANISME DE VALIDATION PAR CASE A COCHER INTITULE &laquo; EN COCHANT CETTE CASE, JE RECONNAIS AVOIR LU ET ACCEPTE LES CONDITIONS GENERALES DU SERVICE LORS DE LA PREMIERE UTILISATION DU SERVICE, APRES CHAQUE MODIFICATION DE CGV AINSI QU’A CHAQUE COMMANDE PAR LE PRODUCTEUR.&raquo;</b>
    </p>
    <p><b>DE MANIERE GENERALE, LE PRODUCTEUR ACCEPTE L’ENSEMBLE DES CONDITIONS GENERALES DE VENTE DU SEUL FAIT DE SON ACCES A L’ESPACE SPECIFIQUE &laquo; COMMANDE D’ALIMENTS &raquo;.</b></p>
    <p><b>Ainsi, le fait pour le Producteur de commander sur le site &laquo; COMMANDE D’ALIMENTS &raquo; emporte adhésion et acceptation pleine et entière des CGV et obligation au paiement des Aliments commandés, ce qui est expressément reconnu par le Producteur, qui renonce, notamment, à se prévaloir de tout document contradictoire, qui serait inopposable au Vendeur.</b></p>

    <h3 class="secondary--text">
      ARTICLE 5. ADHESION AU SERVICE
    </h3>
    <p><b><i>5.1. Adhésion par un Adhérent </i></b></p>
    <p>L’accès et l’utilisation du Service sont exclusivement réservés aux Adhérents qui remplissent cumulativement les conditions suivantes :</p>

    <p>
      a) Être Adhérent de la Coopérative conformément aux dispositions statutaires et être :<br>
      - l’exploitant individuel majeur et capable (pour les Adhérents personnes physiques),<br>
      - le représentant légal ayant le pouvoir d’engager la responsabilité de l’exploitation agricole, et de contracter au nom et pour le compte de la personne morale (pour les Adhérents personnes morales).
    </p>

    <p>
      b) Être détenteur d’un compte Portail Agrial Monagrial<br>

      Chaque Adhérent a un identifiant et un mot de passe strictement personnels et confidentiels (ci-après ses &laquo; Identifiants Personnels &raquo;).<br>

      A ce titre, l’Adhérent déclare fournir des informations exactes, complètes actuelles et s’engage à notifier toute modification de ces informations, chaque fois que nécessaire auprès de la Maison de Région AGRIAL dont il dépend. <br>
      En cas d'oubli de son mot de passe, l'Adhérent devra se rendre sur la page d’accueil du portail adhérent Monagrial, cliquer « mot de passe perdu » et suivre les instructions.
    </p>

    <p>
      c) en cas de nouvel adhérent, demander l’ouverture d’un accès au service commande
      Une première commande auprès du service commande sera nécessaire pour ouvrir l’accès
    </p>

    <p>d) Ne pas avoir de litiges en cours avec AGRIAL.</p>

    <p><b><i>5.2. Adhésion par un Client</i></b></p>

    <p>L’accès et l’utilisation au Service sont exclusivement réservés aux Clients de VEGAM qui remplissent cumulativement les conditions suivantes :</p>
    <p>
      a) Être client agriculteur (exerçant une activité agricole au sens de l’article L 311-1 du code rural et de la pêche maritime) VEGAM et être :
      - l’exploitant individuel majeur et capable (pour les clients personnes physiques),
      - le représentant légal ayant le pouvoir d’engager la responsabilité de l’exploitation agricole, et de contracter au nom et pour le compte de la personne morale (pour les clients personnes morales)
      - avoir son exploitation ou le siège de son exploitation dans les départements suivants : Ille et Vilaine, Côtes d’Armor, Morbihan, Loire Atlantique, Maine et Loire, Manche, Mayenne.
    </p>

    <p>
      b) Être détenteur d’un compte sur le Site COMMANDE D’ALIMENTS.
      Dans le cas contraire, en cas de nouveau client VEGAM, ce dernier devra demander l’ouverture d’un compte au service commande. Après validation de cette inscription, chaque Client a un identifiant et un mot de passe strictement personnels et confidentiels (ci-après ses &laquo; Identifiants Personnels &raquo;).
    </p>
    <p>
      c) Demander l’adhésion, et renseigner les informations nécessaires. Le Client s’engage notamment à apporter une attention particulière à l’information relative à l’adresse électronique « email »et à son numéro de téléphone portable, qui constituent des éléments indispensables dans l’utilisation du Service.<br>

      A ce titre, le Client déclare fournir des informations exactes, complètes actuelles et s’engage à notifier toute modification de ces informations, chaque fois que nécessaire auprès de la Maison de Région dont il dépend.<br>
    </p>

    <p>
      Après acceptation de la demande d’adhésion au Service par VEGAM, le Client devra pour se connecter à ce Service s’identifier avec son Code client VEGAM et son mot de passe.
    </p>

    <p>En cas d'oubli de son mot de passe, le Client devra se rendre sur la page d’accueil du site Monagrial cliquer « mot de passe perdu » et suivre les instructions.</p>

    <p>d) Ne pas avoir de litiges en cours avec VEGAM.</p>

    <h3 class="secondary--text">
      ARTICLE 6. ACCESSIBILITE DU SERVICE COMMANDE D’ALIMENTS
    </h3>
    <p>Le Producteur qui souhaite accéder et utiliser le Service, doit être connecté avec ses Identifiants Personnels qui permettent d’établir son identité. L’autorisation accordée par le Vendeur au Producteur est limitée à l’accès et à l’utilisation du Service pour son usage professionnel.</p>
    <p>Le contenu du Service ne peut être modifié, copié, distribué, encadré, reproduit, téléchargé, affiché, publié, transmis ou encore vendu sous quelque forme que ce soit ou par quelque moyen que ce soit, en tout ou partie, par le Producteur sans l’accord préalable, exprès et écrit du Vendeur.</p>
    <p>Toute utilisation du Service ou de son contenu, autre que celle prévue par les présentes ou en contravention avec la législation applicable ou les droits des tiers est strictement interdite et entrainera la suppression du compte utilisateur du Producteur au Service et sa responsabilité conformément aux lois et dispositions applicables.</p>

    <h3 class="secondary--text">
      ARTICLE 7. ACCESSIBILITE DU SERVICE
    </h3>

    <p><b>7.1.</b> Le Producteur doit au préalable s’assurer qu’il dispose de la configuration et des outils techniques adaptés à l’utilisation du Service, et d’une connexion internet d’un débit suffisant.</p>

    <p><b>7.2.</b> Le Producteur fait son affaire personnelle, à ses frais exclusifs de l’acquisition, la mise en place, la maintenance et la connexion des différents éléments de la configuration et des moyens de télécommunications nécessaires à l’accès au Service. Les coûts de communication et ceux du fournisseur d'accès à Internet sont également à la charge exclusive du Producteur.</p>
    <p>
      <b>7.3.</b> Le Service est exclusivement accessible :
      <ul>
        <li>
          <u><i>Pour l’Adhérent via le portail adhérent Monagrial www.monagrial.com.</i></u><br>
          Après s’être connecté avec ses &laquo; Identifiants Personnels &raquo; sur portail adhérent Agrial, l’Adhérent, pour accéder au Service, à partir de la page d’accueil, cliquer COMMANDE D’ALIMENTS.
        </li>
        <li>
          <u>Pour le Client via le site COMMANDE D’ALIMENTS </u><br>
          Après s’être connecté avec ses &laquo; Identifiants Personnels &raquo; sur le Site COMMANDE D’ALIMENTS, le Client accède au Service à partir de la page d’accueil.
        </li>
      </ul>
    </p>

    <p><b>7.4.</b> Sauf les cas prévus aux présentes CGU, le Service de COMMANDE D’ALIMENTS est accessible tous les jours, 24 heures sur 24. </p>
    <p><b>7.5.</b> AGRIAL et/ou VEGAM se réservant le droit, à tout moment, de modifier ou d’interrompre de manière temporaire tout ou partie du Service pour des raisons techniques de maintenance ou d’amélioration, ou autres et ce sans avoir à en informer préalablement l’Adhérent et/ou le Client. </p>

    <p>AGRIAL et/ou VEGAM donc ne saurait être tenu responsable de tout dommage, quelle qu'en soit la nature, résultant d'une indisponibilité du Service ou d'une ou de plusieurs de ses fonctionnalités. </p>

    <p>
      La responsabilité d’AGRIAL et/ou VEGAM ne pourra ainsi pas être engagée dans le cas où les conditions d'accès au Site ne pourraient être satisfaites en cas de force majeure hors de contrôle du site, d'interruption dans les réseaux et/ou de mauvais fonctionnement de l'outil informatique utilisé par l'Adhérent et/ou le Client.
    </p>

    <p>
      De manière générale, AGRIAL et/ou VEGAM ne pouvant pas garantir un accès continu et sécurisé au Service, dans la mesure où le bon fonctionnement du Service peut être affecté par de nombreux facteurs qu’AGRIAL et/ou VEGAM ne contrôle pas. En conséquence, dans les limites de la législation en vigueur, AGRIAL et/ou VEGAM exclu toutes garanties, conditions ou autres dispositions, et ne peut être tenu pour responsable d'une perte financière ou de réputation, ni des dommages spéciaux, indirects ou induits résultant de ou liés à l'utilisation du site extranet et/ou du Service.
    </p>

    <p>L’obligation d’AGRIAL et/ou VEGAM de fourniture du Service constitue une obligation de moyen.</p>

    <h3 class="secondary--text">
      ARTICLE 8. DESCRIPTION DES ALIMENTS
    </h3>

    <p>
      <b>8.1. Aliments </b><br>
      Les CGV s’appliquent exclusivement à la vente des Aliments référencés et accessibles sur le Site.
      Cette liste est non exhaustive.
    </p>

    <p>Les offres d’Aliments sont valables tant qu'elles sont visibles sur le Site, dans la limite des stocks disponibles et uniquement pour les Aliments référencés pour l’Adhérent.</p>

    <p>
      Les caractéristiques principales des Aliments et notamment les spécifications, des Aliments, sont disponibles auprès des Conseillers.
    </p>

    <p>
      Le Producteur est tenu d'en prendre connaissance avant toute passation de commande.
    </p>

    <p>
      Les photographies et graphismes présentés sur le Site COMMANDE D’ALIMENTS ne sont pas contractuels et ne sauraient engager la responsabilité d’Agrial.
    </p>

    <p>
      Le Producteur est tenu de se reporter aux informations figurant sur l’étiquette de l’Aliment ou de toute autre information jointe à l’Aliment, remise au Producteur (précautions d’emploi, conditions d’utilisation…) afin d'en connaître les propriétés et les particularités essentielles. Seules ces dernières font foi.
    </p>

    <p>
      <b>8.2. Modification/arrêt d’Aliments </b><br>

      Le Vendeur ne pourra en aucun cas être tenu pour responsable des modifications apportées par lui-même ou le fabricant ou le fournisseur sur les compositions, les conditionnements et packaging ou de tout autre décision commerciale et technique qu’il peut être amené à prendre, y compris le retrait ou l’arrêt de la fabrication d’Aliments.
    </p>

    <h3 class="secondary--text">
      ARTICLE 9. CONSULTATIONS DE L’HISTORIQUE DES COMMANDES DU PRODUCTEUR
    </h3>

    <p>
      Toutes les données concernant les tonnages commandés des dernières commandes d’Aliments effectuées entre le Producteur et le Vendeur (12 dernières livraisons ou 18 mois).
    </p>

    <h3 class="secondary--text">
      ARTICLE 10. COMMANDE
    </h3>

    <p>
      Il appartient au Producteur de sélectionner le ou les aliments qu'il désire commander, en cliquant sur le produit, la quantité (tonnes, litres, big-bag, etc…).<br>
      La quantité minimum de commande sera définie en fonction des produits. Ainsi, aucune commande inférieure à 1 Tonne (uniquement l’aliment porcelets et minéraux porcs) ou 2,5 Tonnes pour les autres aliments ne pourra être acceptée par le Vendeur.<br>
      Au moment de passer commande, le Producteur reconnait avoir pris connaissance et accepter les CGV et les informations particulières relatives à chaque Aliment proposé tel que notamment dénomination et poids commandés et le lieu de livraison.
    </p>

    <p>
      Puis, le Producteur indique une date souhaitée de livraison. Cette date n’est qu’indicative. <br>
      Aucune responsabilité du Vendeur ne peut être recherchée par le Producteur en cas de non-respect de cette date indicative.<br>
      - Pour toute commande avant 10 heures le Jour J, la livraison sera effectuée à J+1. <br>
      - Pour commande après 10 heures le jour J, la livraison sera effectuée à J+2.<br>
      Néanmoins, pour certains Aliments à savoir : <br>
      - « GROS BOUCHONS », « TRADI MIX », « TRADI AUGE », les livraisons seront effectuées en vrac dans un délai maximum de 7 jours après la commande. <br>
      - « MINERAL » les livraisons seront effectuées en vrac dans un délai maximum de 10 jours ouvrés après la commande et les livraisons seront effectuées en sac et big bag dans un délai d’environ 3 jours ouvrés après la commande.<br>
    </p>

    <p>Avant de valider définitivement sa commande, le Producteur doit valider son panier de commande.</p>
    <p>
      TOUTE COMMANDE D’ALIMENTS EMISE EN LIGNE SUR L’ESPACE CONSTITUE UN ENGAGEMENT IRREVOCABLE A L’ACHAT DE CES ALIMENTS.
    </p>

    <p>
      Par conséquent, le Producteur accepte et reconnait qu’au travers des commandes qu’il émet, il s’engage contractuellement dans le cadre d’un contrat de vente irrévocable avec le Vendeur.
    </p>

    <h3 class="secondary--text">
      ARTICLE 11. CONFIRMATION ET SUIVI DE LA COMMANDE
    </h3>

    <p>
      <b>11.1. Confirmation </b> <br>
      La vente ne sera considérée comme définitive qu'après l'envoi par e-mail au Producteur de la confirmation de l'acceptation de la commande par le Vendeur indiquant la quantité et le prix HT des Aliments commandés.
      Le Vendeur se réserve le droit d'annuler ou de refuser toute commande d'un Client avec lequel il existerait un litige relatif au paiement d'une commande antérieure.
    </p>

    <p>
      <b>11.2. Suivi de la commande </b><br>
      Le Producteur pourra suivre sur le Site l'évolution de sa commande avec les indications du statut de la commande « en cours » ou « livré ».
    </p>

    <p>
      <b>11.3. Disponibilité de la commande </b><br>
      Dans tous les cas où l’Aliment commandé par le Producteur n’est pas disponible dans les délais raisonnables et dans la quantité de livraison souhaité par ce dernier, le Vendeur s’engage à :<br>
      - Ce qu’un contact soit pris avec le Producteur au Producteur.<br>
      - Ce que l’Aliment commandé ou un Aliment similaire soit rendu disponible dans un délai maximum de trois semaines.<br>
      La liste des Aliments est susceptible d’être modifiée à tout moment par le Vendeur pour mieux répondre aux besoins des Producteurs ou en fonction des Aliments référencés et disponibles.
    </p>

    <h3 class="secondary--text">
      12. TARIFS
    </h3>

    <p>
      Les Aliments sont vendus au poids aux tarifs en vigueur lors de l'enregistrement de sa commande. Les prix sont exprimés en Euros et HT. Ces tarifs comprennent les frais de traitement, d'expédition, de transport et de livraison (sauf vente départ usine).
    </p>

    <p>
      Ces tarifs sont fermes lors de la commande ou au jour de la commande. <br>
      Le Vendeur se réservant le droit de modifier les prix à tout moment.
    </p>

    <p>
      Tolérance : Le Producteur est informé et accepte que le poids des Aliments commandés et livrés peut être inférieur ou supérieur de 1 tonnes.
    </p>

    <p>
      Pour ces « Aliments vendus au poids », le prix facturé au Producteur tient compte de cette variation de quantité et correspond au poids réel de l’Aliment livré.
    </p>

    <p>Le bon de livraison remis lors de la livraison mentionnera le poids des Aliments effectivement livrés. </p>

    <h3 class="secondary--text">
      ARTICLE 13. MODALITES DE PAIEMENT
    </h3>
    <p>Le paiement de la commande par le Producteur s’effectue conformément au mode de paiement sélectionné par le Producteur et autorisé par le Vendeur.</p>
    <p>
      Le Producteur pourra, en fonction de sa qualité (Adhérent) et de son activité et du mode de paiement autorisé par Agrial, et sous réserve des dispositions légales en vigueur, payer sa commande de la manière suivante :
      <ul>
        <li><u><i>Pour l’Adhérent : </i></u> les modalités de paiement d’Agrial </li>
        <li><u><i>Pour le Client :</i></u> selon les modalités de paiement de Vegam pour le Client </li>
      </ul>
    </p>
    <p>Le paiement sera réalisé qu'une fois la livraison des Aliments effectuée conforment aux dispositions de la facture.</p>

    <h3 class="secondary--text">
      ARTICLE 14. LIVRAISON ET RECEPTION DES ALIMENTS
    </h3>

    <p>
      <b>14.1.</b> Sauf accord express entre AGRIAL (service matière première) et le Producteur, la livraison est organisée par AGRIAL par ses propres moyens ou par des transporteurs qu’elle mandate uniquement en France Métropolitaine (hors corse). <br>

      Avant la date prévue pour la livraison, AGRIAL enverra un texto/sms au Producteur lui confirmant le jour de la livraison. <br>

      Les commandes qui ne pourraient être livrées par le Vendeur au Producteur aux dates indiquées dans le texto, du fait d'une défaillance du Vendeur, pourront au choix du Producteur être livrées à une date ultérieure qui ne pourra dépasser 5 jours ouvrés ou être annulées. Toutefois dans ce cas, aucun dommage-intérêt ne sera versé par le Vendeur au Producteur.
    </p>

    <p>
      <b>14.2. Réception des Aliments </b> <br>

      Il appartient au Producteur (ou à son représentant) de vérifier l’état apparent des Aliments livrés.
    </p>
    <p>
      Le Producteur est seul qualifié pour faire des réserves auprès du transporteur, à savoir préciser sur le récépissé de transport les avaries/vices apparents et confirmer ces réserves auprès du transporteur dans les trois (3) jours suivant leur livraison, par lettre recommandée avec accusé de réception, conformément aux dispositions des articles L. 133-3 et suivants du Code de Commerce. Un double de ce courrier devra être adressé en même temps au Vendeur.
    </p>

    <p>
      A défaut, la livraison de la commande sera considérée comme conforme et acceptée.
    </p>

    <p>Il appartiendra au Producteur de fournir toute justification quant à la désignation des vices apparents ou anomalies constatées. Le Producteur devra laisser au Vendeur toute facilité pour procéder à la constatation de ces vices ou non conformités et pour y porter remède le cas échéant. </p>

    <p>La responsabilité du déchargement des Aliments est entièrement à la charge du Producteur. Le Producteur s’engage donc, en acceptant ces CGV, à prendre l’entière responsabilité du déchargement des Aliments livrés.</p>

    <h3 class="secondary--text">
      ARTICLE 15. CLAUSE DE RESERVE DE PROPRIETE
    </h3>

    <p>Les Parties conviennent que la propriété des Aliments vendus par le Vendeur ne sera transférée au Producteur qu’après complet du prix desdits Aliments.</p>

    <p>Le Vendeur ou ses ayants droit se réservent la propriété des Aliments livrés par lui jusqu'au paiement intégral de toutes les sommes qui lui sont dues par le Producteur, lui permettant de reprendre possession desdits Aliments en cas de défaut de paiement. Tout acompte versé par le Producteur restera acquis au Vendeur à titre d’indemnisation forfaitaire, sans préjudice de toutes autres actions qu’il serait en droit d’intenter de ce fait à l’encontre du Producteur.</p>
    <h3 class="secondary--text">
      ARTICLE 16. TRANSFERT DES RISQUES
    </h3>

    <p>
      Quelle que soit la date du transfert de propriété des Aliments, le transfert des risques de perte et de détérioration s'y rapportant, ne sera réalisé qu'au moment où le Producteur prendra physiquement possession des Aliments. Les Produits voyagent donc aux risques et périls du Vendeur.<br>
      Par exception, le transfert des risques aura lieu au départ de l’usine en cas de vente au départ usine choisie par le Producteur et accepté par le Vendeur.
    </p>

    <h3 class="secondary--text">
      ARTICLE 17. OBLIGATIONS DU PRODUCTEUR AU REGARD DE L’UTILISATION DU SERVICE
    </h3>

    <p><b>17.1.</b> Le Producteur s’engage à assurer la confidentialité de ses Identifiants personnels et devra s’assurer en toute circonstance qu’ils ne seront pas divulgués à des tiers. Le Producteur est responsable de tous les actes effectués à partir de son compte utilisateur. </p>

    <p>
      <b>17.2.</b> Le Producteur qui souhaite accéder et commander sur le Service s'engage expressément à ne pas utiliser de fausses informations ou des informations de tiers et déclare avoir la capacité requise pour contracter et acquérir les Aliments proposés à la vente par Vendeur. Le Producteur accepte l'utilisation du Service fourni en l'état.
    </p>

    <p><b>17.3.</b>Si le Producteur estime qu’il y a eu une atteinte à la sécurité de ses Identifiants personnels telle qu’une divulgation, un vol ou une utilisation non autorisée, le Producteur devra immédiatement prévenir le Vendeur par courriel à l’adresse suivante : Contact.commande-aliments@agrial.com. </p>

    <p><b>17.4.</b>Le Producteur s’engage à utiliser le Service dans le respect des CGV et de la loi applicable. En conséquence, il accepte notamment de ne pas entraver ou fausser le fonctionnement du Service, porter atteinte à tout ou partie des éléments du Site COMMANDE D’ALIMENTS, ou accéder de manière frauduleuse au Service COMMANDE D’ALIMENTS.</p>
    <p><b>17.5.</b> Le Producteur veillera à se déconnecter de son compte à l’issue de chaque utilisation du Site COMMANDE D’ALIMENTS en particulier si sa connexion se fait depuis un outil technique de communication partagé.</p>

    <h3 class="secondary--text">
      ARTICLE 18. RESPONSABILITE DU PRODUCTEUR- EXCLUSION DU DROIT DE RETRACTATION
    </h3>

    <p><b>18.1.</b>Le Producteur assume personnellement la pleine et entière responsabilité et les conséquences de toutes les actions qu’il effectue sur le Site COMMANDE D’ALIMENTS.</p>

    <p>
      <b>18.2.</b> Mise en garde particulière : Le Producteur reconnaît et accepte sans réserve être pleinement responsable de toute action entreprise faisant suite à la lecture de ses historiques des commandes, et de manière générale de toutes données et informations présentes sur le Site COMMANDE D’ALIMENTS.
      Le Producteur est pleinement conscient du caractère aléatoire et du risque pris lors des commandes qu’il effectue et en conserve la pleine et entière responsabilité.
    </p>

    <p><b>18.3.</b>Il est rappelé que le Producteur agissant en qualité de professionnel ne dispose pas de la faculté de rétracter sa commande. Par conséquent, le Producteur est lié contractuellement au Vendeur sans faculté de rétractation.</p>

    <h3 class="secondary--text">
      ARTICLE 19. CONVENTION SUR LA PREUVE
    </h3>

    <p>
      Les informations relatives à l’ensemble des consultations, validation et confirmation de commande, sont stockées et archivées durant un délai de 10 ans. Les données électroniques conservées sur le Site COMMANDE D’ALIMENTS font foi, jusqu’à preuve du contraire, des commandes passées et de l’ensemble des transactions conclues par le Producteur sur cet espace. Les systèmes d'enregistrement automatique des données issues et transmises au Service COMMANDE D’ALIMENTS sont considérés comme valant preuve, de la nature, du contenu et de la date de l’utilisation du Service.
    </p>

    <p>
      Ces données électroniques constituent donc des preuves recevables, valables et opposables dans les mêmes conditions et avec la même force probante que tout document qui serait établi, reçu ou conservé sur support papier.
    </p>

    <h3 class="secondary--text">
      ARTICLE 20. MODIFICATIONS
    </h3>

    <p>
      <b>20.1. Modifications relatives aux CGU </b><br>
      Le Vendeur se réserve le droit d’adapter et de modifier à tout moment, pour des raisons techniques, financières ou relatives à la sécurité les CGV, sans encourir une quelconque responsabilité vis-à-vis du Producteur. Etant précisé que les CGV applicables sont celles en vigueur au jour de la commande du Producteur sur le Service COMMANDE D’ALIMENTS.
    </p>

    <p>
      <b>20.2. Modifications relatives au Service </b><br>
      Le Vendeur se réserve la possibilité de supprimer ou de modifier en tout ou partie le Service accessible au Producteur, sans encourir une quelconque responsabilité vis-à-vis du Producteur.
    </p>

    <p>
      <b>20.3. Entrée en vigueur des modifications des CGU </b><br>

      Les modifications entrent en vigueur à compter de leur mise en ligne sur le Site COMMANDE D’ALIMENTS. Le non-respect de ces modifications ou de ces nouvelles conditions techniques ou sécuritaires, peuvent entrainer la suspension de l’adhésion au Service, et/ou la fin de l’accès au Service en cas de risques importants.
    </p>

    <h3 class="secondary--text">
      ARTICLE 21. SUSPENSION – RESILIATION ANTICIPEE DU PRODUCTEUR AU SERVICE
    </h3>

    <p>Lorsqu’un Producteur contrevient ou ne respecte plus une des conditions des CGV ou plus largement, aux lois, et règlementations en vigueur, le Vendeur se réserve le droit (sans délai, ni formalité) de suspendre ou de supprimer définitivement le compte utilisateur du Producteur au Service et de lui interdire de s’inscrire à nouveau, sans préjudice de toute action ou poursuite du Vendeur. </p>

    <h3 class="secondary--text">
      ARTICLE 22. DROITS DE PROPRIETE INTELLECTUELLE
    </h3>

    <p>
      Tous les éléments du Service (textes, photographies, illustrations, marques, logo, icônes, images, éléments graphiques ou sonores, mises en page, bases de données etc.) sont la propriété exclusive du Vendeur, ses filiales et/ou de ses partenaires titulaires de droits de propriété intellectuelle y afférent. Ces éléments sont protégés par les lois françaises et les textes internationaux relatifs au respect des droits d’auteur, marques, dessins et modèles, brevets, etc…
    </p>
    <p>
      La mise en ligne du Service n’emporte pas la licence d’utilisation des éléments qui y figurent, une telle utilisation étant subordonnée au consentement écrit, préalable et exprès du propriétaire de ces éléments.
    </p>

    <p>Toute reproduction ou représentation même partielle par quelque procédé que ce soit, réalisée sans le consentement écrit, préalable et exprès d’Agrial ou ses sociétés affiliées dont Vegam, et/ou de ses partenaires lorsque ceux- ci sont titulaires des droits, est interdite et illicite. Le non-respect de cette interdiction constitue une contrefaçon ou un acte de concurrence déloyale pouvant engager la responsabilité civile et pénale de l’auteur.</p>

    <p>
      La mise en place de liens hypertextes vers toute page du service est INTERDITE.
    </p>

    <p>
      Toute utilisation des éléments du Service à des fins autres que celles prévues aux CGV, notamment à des fins publiques, commerciales ou humoristiques, pourra faire l’objet de poursuites judiciaires en France comme à l’étranger.
    </p>

    <h3 class="secondary--text">
      ARTICLE 23. CONFIDENTIALITE ET PROTECTION DES DONNEES PERSONNELLES
    </h3>

    <p>
      Le Vendeur assure la confidentialité des données personnelles qui lui sont confiées par le Producteur dans le respect des dispositions légales et réglementaires en vigueur ainsi que des meilleures pratiques de sa profession.
    </p>

    <p>
      Les données du Producteur recueillies par le Vendeur au titre de ce Service sont les suivantes : date de la commande, prénom, nom, pour un Adhérent : numéro du compte Adhérent ou pour un Client : numéro du compte Client Vegam, adresse de livraison, adresse de l’exploitation, adresse de facturation, numéros de téléphone, adresses mail, nom du produit, quantité, prix, mode de livraison, tonnages commandés, modalités de paiement.
    </p>

    <p>
      En application de la loi 78-17 du 6 janvier 1978 modifiée par la loi n°2018-493 du 20 juin 2018, les données personnelles du Producteur sont recueillies par le Vendeur, responsable du traitement, pour les finalités suivantes : l’adhésion au Service, l’ouverture du compte utilisateur au Service, les besoins inhérents l’utilisation du Service, le traitement des commandes et l'établissement des documents de transports (bon de livraison), des factures.
    </p>

    <p>
      Ces données peuvent être communiquées aux éventuels partenaires du Vendeur chargés de l'exécution, du traitement, de la fabrication de la commande, de la gestion du transport et/ou de la facturation des commandes.
    </p>

    <p>En particulier, les données personnelles du Producteur collectées dans le cadre de ce Service ne seront ni vendues ni louées à d’éventuelles sociétés tiers à Agrial et ses Sociétés affiliées (au sens de l’article L 233-3 du Code de commerce) dont Vegam sans que le consentement du Producteur n’ait été recueilli de manière préalable et explicite.</p>

    <p>
      Le Producteur est également informé qu’il aura à tout moment la possibilité de recourir à l’autorité de contrôle compétente désignée par la législation : la Commission Nationale de l’Informatique et des Libertés (CNIL) (www.cnil.fr).
    </p>

    <p>
      <u>Pour un Adhérent: </u><br>
      Les données personnelles seront conservées par Agrial pour toute la durée de son engagement coopératif.<br>

      Agrial s’engage à ne pas conserver pour ce Service les données personnelles de l’Adhérent au-delà d’un délai de 48 mois suivant le terme de l’engagement coopératif de l’Adhérent.
    </p>

    <p>
      <u>Pour un Client : </u><br>
      Les données personnelles seront conservées par Vegam pour toute la durée d’adhésion au Service celle-ci étant lié à la titularité d’un compte client Vegam.<br>
      Vegam s’engage à ne pas conserver pour ce Service les données personnelles du Client au-delà d’un délai de 48 mois suivant le terme de son adhésion au Service.
    </p>
    <h3 class="secondary--text">
      ARTICLE 24. FORCE MAJEURE
    </h3>
    <p>
      Les Parties ne pourront être tenues pour responsables si la non-exécution ou le retard dans l'exécution de l'une quelconque de leurs obligations, telles que décrites dans les CGV découle d'un cas de force majeure, au sens de l'article 1218 du Code civil ou de la jurisprudence française, ou cas fortuits, les évènements ayant pour conséquence d’empêcher ou de restreindre ou de retarder la vente, la fabrication, le transport ou la livraison des Aliments ou matières premières dans de bonnes conditions, ou mettant en jeu la sécurité des matériels et ou des personnes ; ainsi que notamment les cas de guerre, émeute, grève, grève ou blocage en mer de navire, épidémie, évènements climatiques (inondations etc…), accidents graves de matériels ou d’outillage, la mobilisation, les interruptions de transports, la pénurie de matières premières, l’interdiction de distribution d’un aliment composé ou simple, ou d’un de ses composants la modification des règlements de douanes ou de contingentement, ainsi que la non obtention ou la réduction des licences éventuellement nécessaires à l’importation, l’impossibilité d’être approvisionné, accident, incendie, la destruction de tout ou partie des Aliments ou matières premières, la détérioration, la dégradation ou la privation de tout ou partie des installations et moyens de vente, de fabrication, ou de livraison des Aliments ou matières premières au Vendeur ou sociétés fournisseurs, partenaires ou affiliées.
    </p>
    <p>
      La Partie constatant l'événement devra sans délai informer l'autre Partie de son impossibilité à exécuter sa prestation et s'en justifier auprès de celle-ci. La suspension des obligations ne pourra en aucun cas être une cause de responsabilité pour non-exécution de l'obligation en cause, ni induire le versement de dommages et intérêts ou pénalités de retard.
    </p>
    <p>
      L'exécution de l'obligation est suspendue pendant toute la durée de la force majeure si elle est temporaire. Par conséquent, dès la disparition de la cause de la suspension de leurs obligations réciproques, les Parties feront tous leurs efforts pour reprendre le plus rapidement possible l'exécution normale de leurs obligations contractuelles. A cet effet, la Partie empêchée avertira l'autre de la reprise de son obligation. Si l'empêchement est définitif, la commande sera purement et simplement résolue.
    </p>
    <p>
      Si l’empêchement est d’une durée supérieure à 90 jours, l’une ou l’autre des Parties pourra résilier la commande, sous réserve d’en informer l’autre Partie.
    </p>
    <h3 class="secondary--text">
      ARTICLE 25. ASSURANCE
    </h3>
    <p>
      Le Producteur devra souscrire auprès d’une compagnie d’assurance notoirement solvable, les polices d’assurances nécessaires à la couverture des risques, tant à l’égard du Vendeur que des tiers, résultant de son activité professionnelle et/ou des obligations découlant des commandes faites sur le Service ou en relation avec celles-ci.
      Toute modification, suspension, résolution (ou résiliation) de cette police d'assurance, pour quelque cause que ce soit, devra être immédiatement notifiée au Vendeur.
    </p>

    <h3 class="secondary--text">
      ARTICLE 26. DISPOSITIONS DIVERSES
    </h3>

    <p>
      <b><u>Imprévision </u></b><br>

      En cas de changement de circonstances durant l’exécution de la commande imprévisible lors de sa conclusion, conformément aux dispositions l’alinéa 1 de l'article 1195 du Code civil, la partie qui n'a pas accepté d'assumer un risque d'exécution excessivement onéreuse peut demander une renégociation de la commande (contrat de vente) à son cocontractant, par tout moyen écrit.
      Les Parties s’efforceront de négocier de bonne foi, pendant un délai de trente (30) jours calendaires maximum, afin de tenter de trouver un accord sur les nouvelles conditions contractuelles applicables.
      Tous les échanges entre les Parties durant cette phase de négociation seront confidentiels et ne pourront en aucun cas être considérés comme valant reconnaissance de responsabilité et les éléments reçus de l’autre Partie pas usage en cas de litige. <br>
      En cas de refus ou d’échec dans les négociations, et par dérogation à l’alinéa 2 de l’article 1195 du Code civil, les Parties renoncent à demander une fixation judicaire du prix et pourront se retirer de plein droit du contrat de vente.
    </p>

    <p>
      <b><u>Exécution forcée en nature</u></b><br>

      Par dérogation aux dispositions de l'article 1221 du Code civil, les Parties conviennent qu'en cas de manquement de l'une ou l'autre des Parties à ses obligations, la Partie victime de la défaillance ne pourra pas en demander l'exécution forcée.
    </p>

    <p>
      <b><u>Indépendance</u></b><br>
      Les Parties exerceront leur activité en leur nom propre et pour leur propre compte, en qualité d’acteur juridique indépendant l’une envers l’autre, sans que les transactions réalisées sur le Service ne puisse créer entre elles une quelconque filiale, entreprise commune ou une entité juridique quelconque, ni un quelconque lien de subordination ou de représentation, mandat ou analogue.
    </p>

    <p>
      <b><u>Nullité</u></b><br>
      Si une ou plusieurs dispositions des CGV sont tenues pour non valides notamment pour une raison légale, elles seront réputées non-écrites, et toutes les autres dispositions garderont toute leur force. Il en sera de même en cas d’absence d’une mention légale obligatoire.
    </p>
    <p>
      <b><u>Cession de l’adhésion au Service </u></b><br>
      L’adhésion au Service ne peut être cédée ou transférée en tout ou en partie à un tiers. Par exception, le Vendeur pourra, ce que le Producteur accepte, céder ou transférer l’adhésion à toute société filiale d’AGRIAL au sens de l’article L233-3 du code de commerce.
    </p>

    <p>
      <b><u>Intégralité</u></b><br>
      Les CGU expriment l'intégralité des engagements des Parties. Sauf dérogation formelle et expresse des Parties, chacune des Parties renonce expressément à l’application de ses propres conditions générales d’utilisations, de ventes et/ou conditions générales d’achat.
    </p>
    <p>
      <b><u>Tolérance</u></b><br>
      Les Parties conviennent réciproquement que le fait, pour l'une des Parties de tolérer une situation, n'a pas pour effet d'accorder à l'autre partie des droits acquis. De plus, une telle tolérance ne peut être interprétée comme une renonciation à faire valoir les droits en cause.
    </p>

    <h3 class="secondary--text">
      ARTICLE 27. DROIT APPLICABLE ET JURIDICTION COMPETENTE
    </h3>

    <p>
      <b>27.1.</b> Les CGU sont soumises à la loi française.
    </p>

    <p>
      <b>27.2. Dispositions Agrial – Producteur Adhérent </b><br>

      En cas de litige relatif à la validité, l’interprétation, l’exécution, ou encore la résolution, des dispositions prévues ci-dessus, leurs conséquences et leurs suites, les Parties s’engagent à se rapprocher pour tenter de trouver une solution amiable. <br>
      Faute d’y parvenir dans un délai de trente (30) jours, la partie y ayant intérêt pourra, préalablement à toute saisine du Tribunal de Grande Instance de CAEN, demander la mise en œuvre d’une procédure de médiation auprès du médiateur de la coopération agricole.
    </p>

    <p>
      <b>27.3. Dispositions Vegam – Producteur Client </b><br>

      En cas de litige relatif à la validité, l’interprétation, l’exécution, ou encore la résolution, des dispositions prévues ci-dessus, leurs conséquences et leurs suites, les Parties s’engagent à se rapprocher pour tenter de trouver une solution amiable. <br>
      Faute d’y parvenir dans un délai de trente (30) jours, la partie y ayant intérêt pourra, préalablement à toute saisine du Tribunal compétent de RENNES, demander la mise en œuvre d’une procédure de médiation auprès du médiateur des relations commerciales agricoles.
    </p>

    <i>Dernière mise à jour le 27/11/2020</i>
    <br>
    <br> <br>
    <br>
  </div>
</template>

<style lang="scss" scoped>
.content {
  margin: 3vw;
  padding: 2vw;
  background-color: #f4f8f9;
}

.secondary--text {
  font-weight: 300;
  text-decoration: underline;
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'xs-only')} {
  .content {
    margin: 0;
    padding: 3vw;
  }
}
</style>
